import { render, staticRenderFns } from "./Lgx328192071175241728.vue?vue&type=template&id=23229598&scoped=true&"
import script from "./Lgx328192071175241728.vue?vue&type=script&lang=js&"
export * from "./Lgx328192071175241728.vue?vue&type=script&lang=js&"
import style0 from "./Lgx328192071175241728.vue?vue&type=style&index=0&id=23229598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23229598",
  null
  
)

export default component.exports